import styled from "styled-components";
import {
  CHEVRON_ORIENTATION_DOWN,
  CHEVRON_ORIENTATION_LEFT,
  CHEVRON_ORIENTATION_RIGHT,
  ChevronOrientation,
} from "./constants";

export const ChevronIconWrapper = styled.div<{ $orientation: ChevronOrientation }>`
  transition: transform 0.25s ease-in-out;
  transform: rotate(
    ${(props) =>
      props.$orientation === CHEVRON_ORIENTATION_RIGHT
        ? "0"
        : props.$orientation === CHEVRON_ORIENTATION_DOWN
          ? "90deg"
          : props.$orientation === CHEVRON_ORIENTATION_LEFT
            ? "180deg"
            : "270deg"}
  );
`;

export const ArrowIconWrapper = styled.div<{ $orientation: ChevronOrientation }>`
  display: flex;
  justify-content: center;
  align-items: center;
  transform: rotate(${(props) => (props.$orientation === CHEVRON_ORIENTATION_RIGHT ? "180" : "0")}deg);
`;
